import { QueryKey } from '@tanstack/query-core';

export const createQueryKeys = <
  BaseKey extends string,
  TFilter extends object | undefined = undefined,
  TOther extends Record<string, QueryKey | ((...args: any[]) => QueryKey)> = {},
>(
  baseKey: BaseKey,
  filter?: TFilter,
  other?: TOther,
) => {
  const listQueryKey = 'list' as const;
  const loadQueryKey = 'load' as const;

  const base = {
    list: [baseKey, listQueryKey] as const,
    listWithFilter: [baseKey, listQueryKey, filter] as const,
    byId: (id: number) => [baseKey, loadQueryKey, id] as const,
  };

  return {
    ...base,
    ...other,
  } as const satisfies typeof base & TOther;
};
